
export default {
    name: "InternalFooter",
    components: {
    },

    data() {
        return {
            showPrivacyPolicyModal: false,
            showPrivacyPolicyChildrenModal: false,
            showUseTermsModal: false,
        }
    },

    
};
